import Form from "@components/shared/form";
import React, { ReactElement } from "react";
import styles from "./styles.module.scss";
import { useDomainContext } from "@hooks/useDomainContext";
import { useRouter } from "next/router";
import { finalShowForm } from "@lib/sharedUtils";
import TextBlockOffer from "@components/shared/textBlockOffer/TextBlockOffer";
export default function CategoryForm(): ReactElement {
    const router = useRouter();
    const { domain } = useDomainContext();
    const isFormDisplayed = finalShowForm(
        router.query.sl as string,
        domain.showForm,
        domain.defaultOffers,
    );
    return (
        <>
            {isFormDisplayed ? (
                <div className={` ${styles["mainSection"]}`}>
                    <div className="pt-24 pb-80">
                        <Form
                            colors={{
                                primaryColor: "#ffc659",
                                progressBar: "grey",
                            }}
                            classes={{
                                formClassName: styles["form"],
                                formButtonClassName: styles["form-button"],
                                formStepInnerClassName: styles["form-inner"],
                                stepClassName: styles["step"],

                                fieldsClassName: {
                                    radio: styles["radio-field"],
                                    checkbox: styles["checkbox-field"],
                                    all: styles["field"],
                                },
                                formFieldClassName: styles["field-wrapper"],
                                stepTitleClassName: styles["step-title"],
                                stepDescriptionClassName:
                                    styles["step-description"],
                                formProgressbarClassName:
                                    styles["progress-bar"],
                                labelAsTitleClassName:
                                    styles["label-as-step-title"],
                                tcpaClassName: styles["tcpa"],
                            }}
                            showProgress
                            popupStyle={{
                                actionBtnBgColor: "#063C58",
                                iconColor: "#063C58",
                            }}
                        />
                    </div>
                </div>
            ) : (
                <TextBlockOffer />
            )}
        </>
    );
}
